import { Injectable, NgZone } from "@angular/core";
import { CameraOptions } from '@ionic-native/camera';
import { CameraNative } from '../../../native/camera.native';
import { FileUploaderProvider, OptionsUploadWithHttp } from '../../../providers/file-uploader/file-uploader';
import { GlobalServiceProvider } from "../../../providers/global-service/global-service";
import { RequestDevice, ResponseDevice, ResponseListingUserTenant, RequestListingCompanyTenant, RequestAttendanceTempLog, ResponseAttendanceTempDetailLoc, RequestSaveCompanyTenant, RequestSaveUserTenant, ResponseSetUserNotInDevice, ResponseSyncUserNotInSpecificDevice, ResponseSyncUserNotInDevice, ResponseSyncRawData, RequestListingTimeZone } from "../../../shared/nestjs/gd-only/dto/face-thermal.dto";
import { FaceThermalApi } from "../../../shared/nestjs/gd-only/services/face-thermal.api";
import { NestResponsesProvider, ResponseData } from "../../../shared/nestjs/nest-responses";
import { AttendanceApi } from '../../../shared/thermal/services/attendance.api';
import { ConfigApi } from "../../../shared/thermal/services/config.api";
import { FaceApi } from '../../../shared/thermal/services/face.api';
import { PersonsApi } from "../../../shared/thermal/services/persons.api";
import { ThermalApi } from "../../../shared/thermal/thermal-api";
import { FaceThermalUserApi } from "../../../shared/nestjs/gd-only/services/face-thermal-user.api";
import { Subscription, Subject } from "rxjs";
import { RequestEmployeeNotif, ResponseEmployeeNotif } from "../../../shared/nestjs/gd-only/dto/face-thermal-user.dto";
import { EmployeesApi } from "../../../shared/nestjs/gd-only/services/employees.api";
import { ResponseSearchDto } from "../../../shared/nestjs/gd-only/dto/employees.dto";
import { FaceThermalDashboardUserLoginApi } from "../../../shared/nestjs/gd-only/services/face-thermal-dashboard-users-login.api";
import { RequestDashboardUserLoginDto } from "../../../shared/nestjs/gd-only/dto/face-thermal-dashboard-users-login.dto";
import { ResponsePaging } from "../../../shared/thermal/thermal-responses";
import { CallNumber } from "@ionic-native/call-number";
import { ImagePickerNative } from "../../../native/image-picker.native";
import { ImagePickerOptions } from "@ionic-native/image-picker";
import { FileTransferNative, FileTransferHttpOptions } from "../../../native/file-transfer.native";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { FormDataUpload } from "../../../shared/nestjs/nest-api";
import { Platform } from "ionic-angular";
import { StoragePathProvider } from "../../../providers/storage-path/storage-path";
import { AppPreferences } from "../../../shared/local/app-preferences.local";
import moment from "moment";
import { AttendanceFaceRecognizeApi } from "../../../shared/thermal/services/attendance-face-recognize.api";
import { TitleCasePipe } from "@angular/common";

@Injectable()
export class FaceThermalBloc {

	public subscriptions: Array<Subscription> = [];
	public getDeviceAndSyncListener = new Subject<string>();
	private _progressSyncAttendance = '';
	private _percentageSyncAttendance = 0;
  private userNotDevice = {
    userNoQualifiedFoto: [],
    userErrorUploadFoto: [],
    userFotoToUpload: 0,
    usersSuccessUploaded: [],
    usersNotInDevice: []
  }

	constructor(
		private faceThermalApi: FaceThermalApi,
		private faceThermalUserApi: FaceThermalUserApi,
		private personsApi: PersonsApi,
		public nestResponsesProvider: NestResponsesProvider,
		private thermalApi: ThermalApi,
		private faceApi: FaceApi,
		private cameraNative: CameraNative,
		private fileUploader: FileUploaderProvider,
		private attendanceApi: AttendanceApi,
		private globalServiceProvider: GlobalServiceProvider,
		private configApi: ConfigApi,
		private employeesApi: EmployeesApi,
		private faceThermalDashboardUserLoginApi: FaceThermalDashboardUserLoginApi,
		private callNumber: CallNumber,
		private imagePickerNative: ImagePickerNative,
		private fileTransferNative: FileTransferNative,
		private platform: Platform,
		private storagePathProvider: StoragePathProvider,
		private appPreferences: AppPreferences,
		private ngZone: NgZone,
		private attendanceFaceRecognizeApi: AttendanceFaceRecognizeApi,
		private titleCasePipe: TitleCasePipe
	) { }

	// Greatday Server
	setBaseUrlDevice(path: string) {
		this.thermalApi.setBaseUrl(path);
	}

	dispose() {
		this.subscriptions.forEach(item => item.unsubscribe());
	}

	get progressSyncAttendance() {
		return this._progressSyncAttendance;
	}

	get percentageSyncAttendance() {
		return this._percentageSyncAttendance;
	}

	// private publishProgressSyncAttendance(data) {
	// 	this.ngZone.run(() => {
	// 		this._progressSyncAttendance = data;
	// 	});
	// }

	publishProgressSyncAttendance(data) {
		this.ngZone.run(() => {
			this._progressSyncAttendance = data;
		});
	}

	// private publishPercentageSyncAttendance(data) {
	// 	this.ngZone.run(() => {
	// 		this._percentageSyncAttendance = data;
	// 	});
	// }

	publishPercentageSyncAttendance(data) {
		this.ngZone.run(() => {
			this._percentageSyncAttendance = data;
		});
	}

	async getDevice() {
		try {
			const data = await this.faceThermalApi.getDevice().toPromise();
			return data.data;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async getDeviceTigersoft() {
		try {
			const data = await this.faceThermalApi.getDeviceTigersoft().toPromise();
			return data.data;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async setDevice(data: RequestDevice) {
		try {
			const res = await this.faceThermalApi.saveDevice(data).toPromise();
			return res.message;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async removeDevice(id: any) {
		try {
			const res = await this.faceThermalApi.removeDevice({ id: id }).toPromise();
			return res.message;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async getDeviceAndSync(deviceList: any[]) {
		try {
			for (let item of deviceList) {
				try {
					this.thermalApi.setBaseUrl(item.host);
					const persons: any = await this.personsApi.findByPage('12345678', -1, 20000, 0);

					const response = persons;
					if (response.success) {
						item.user = response.data.records;
						item.totalUser = response.data.records.length;
						item.connected = true;
						item.connecting = false;
						item.message = "";
					} else {
						item.user = [];
						item.totalUser = 0;
						item.connected = false;
						item.message = response.msg;
					}
				} catch (error) {
					item.user = [];
					item.totalUser = 0;
					item.connected = false;
					item.connecting = false;
					item.message = "Sorry, something went wrong";
				}
			}
			return deviceList;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async singleSyncDevice(item: any) {
		try {
			try {
				this.thermalApi.setBaseUrl(item.host);
				const persons: any = await this.personsApi.findByPage('12345678', -1, 20000, 0);
				console.log('persons', persons);

				const response = persons;
				if (response.success) {
					item.user = response.data.records;
					item.totalUser = response.data.records.length;
					item.connected = true;
					item.connecting = false;
					item.message = "";
				} else {
					item.user = [];
					item.totalUser = 0;
					item.connected = false;
					item.message = response.msg;
				}
			} catch (error) {
				item.user = [];
				item.totalUser = 0;
				item.connected = false;
				item.connecting = false;
				item.message = "Sorry, something went wrong";
			}
			return item;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				throw this.nestResponsesProvider.handleMsgError(error);
			}
		}
	}

	async singleSyncDeviceTigersoft(item: any) {
		try {
			try {
				const persons: any = await this.faceThermalApi.getEmpTigersoft(item.uuid).toPromise();
				console.log('persons', persons);

				const response = persons;
				// if (response.device.Status = 'Online') {
					if (response.device.StatusDevice) {
					item.user = response.data;
					item.totalUser = response.data.length;
					item.connected = true;
					item.connecting = false;
					item.message = "";
				} else {
					item.user = [];
					item.totalUser = 0;
					item.connected = false;
					item.connecting = false;
					item.message = "Machine is offline";
				}
			} catch (error) {
				item.user = [];
				item.totalUser = 0;
				item.connected = false;
				item.connecting = false;
				item.message = "Sorry, something went wrong";
			}
			return item;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				throw this.nestResponsesProvider.handleMsgError(error);
			}
		}
	}

	async getUserByDevice(item: any) {
		try {
			try {
				this.thermalApi.setBaseUrl(item.host);
				const persons: any = await this.personsApi.findByPage('12345678', -1, 20000, 0);
				console.log('TCL: persons', persons)
				const response = persons
				if (response.success) {
					item.user = response.data.records;
					item.totalUser = response.data.records.length;
					item.connected = true;
					item.connecting = false;
					item.message = "";
				} else {
					item.user = [];
					item.totalUser = 0;
					item.connected = false;
					item.message = response.msg;
				}
			} catch (error) {
				item.user = [];
				item.totalUser = 0;
				item.connected = false;
				item.connecting = false;
				item.message = "Sorry, something went wrong";
			}
			return item;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async getUserByDeviceTigersoft(item: any) {
		try {
			try {
				// this.thermalApi.setBaseUrl(item.host);
				const persons: any = await this.faceThermalApi.getEmpTigersoft(item.uuid);
				console.log('TCL: persons', persons)
				const response = persons
				if (response.success) {
					item.user = response.data.records;
					item.totalUser = response.data.records.length;
					item.connected = true;
					item.connecting = false;
					item.message = "";
				} else {
					item.user = [];
					item.totalUser = 0;
					item.connected = false;
					item.message = response.msg;
				}
			} catch (error) {
				item.user = [];
				item.totalUser = 0;
				item.connected = false;
				item.connecting = false;
				item.message = "Sorry, something went wrong";
			}
			return item;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async getDeviceAndAttendance(item: any) {
		try {
			try {
				this.thermalApi.setBaseUrl(item.host);
				const newRecord = await this.getNewRecord();
				item.record = newRecord;
				item.totalUser = newRecord.length;
				item.connected = true;
				item.connecting = false;
				item.message = "";
			} catch (error) {
				item.record = [];
				item.totalUser = 0;
				item.connected = false;
				item.connecting = false;
				item.message = "Sorry, something went wrong";
			}

			return item;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async syncUserNotInDevice(data: ResponseDevice[]): Promise<ResponseSyncUserNotInDevice> {
		const dataFilter = data.filter(x => x.connected == true)
		let result: Array<{ deviceId: any, deviceName: string, result: ResponseSyncUserNotInSpecificDevice, success: boolean }> = []

		for (const item of dataFilter) {
			try {
				// this.thermalApi.setBaseUrl(item.host);
				const persons = item.user.map((x: any) => x.userId);
				const userNotDevice = await this.faceThermalApi.getUserNotInDevice(persons).toPromise();
				const guestNotDevice = await this.faceThermalApi.getGuestNotInDevice(persons).toPromise();
				const tenantNotInDevice = await this.faceThermalApi.getTenantNotInDevice(persons).toPromise();

				let setEmployee: ResponseSetUserNotInDevice = { userErrorUploadFoto: [], userNoQualifiedFoto: [], usersSuccessUploaded: [], usersNotInDevice: [], userFotoToUpload: 0 };
				let setGuest: ResponseSetUserNotInDevice = { userErrorUploadFoto: [], userNoQualifiedFoto: [], usersSuccessUploaded: [], usersNotInDevice: [], userFotoToUpload: 0 };
				let setTenant: ResponseSetUserNotInDevice = { userErrorUploadFoto: [], userNoQualifiedFoto: [], usersSuccessUploaded: [], usersNotInDevice: [], userFotoToUpload: 0 };;

        let count = 1;

				try {
          if (userNotDevice.data.length > 0){
            for (let item of userNotDevice.data) {
              const message = `Send ${count} of ${userNotDevice.data.length} data employee`;
              this.publishProgressSyncAttendance(message);

              setEmployee = await this.setUserNotInDevices('employee', item, item.uuid);

              try {
                const percent = Math.ceil((count / userNotDevice.data.length) * 100);
                this.publishPercentageSyncAttendance(percent);
              } catch (error) {
                console.log('TCL: error percentage', error);
              }

              count++;
            }

          this.resetProgressSyncRawAttendance();
          }
        } catch (error) {
          console.log('TCL: error set data employee', error);
        }

        try {
          if (guestNotDevice.data.length > 0) {
            for (let item of guestNotDevice.data) {
              const message = `Send ${count} of ${guestNotDevice.data.length} data guest`;
              this.publishProgressSyncAttendance(message);

              setGuest = await this.setUserNotInDevices('guest', item, item.uuid);

              try {
                const percent = Math.ceil((count / guestNotDevice.data.length) * 100);
                this.publishPercentageSyncAttendance(percent);
              } catch (error) {
                console.log('TCL: error percentage', error);
              }

              count++;
            }

          this.resetProgressSyncRawAttendance();
          }
        } catch (error) {
          console.log('TCL: error set data guest', error);
        }

        try {
          if (tenantNotInDevice.data.length > 0) {
            for (let item of tenantNotInDevice.data) {
              const message = `Send ${count} of ${tenantNotInDevice.data.length} data guest`;
              this.publishProgressSyncAttendance(message);

              setTenant = await this.setUserNotInDevices('tenant', item, item.uuid);

              try {
                const percent = Math.ceil((count / tenantNotInDevice.data.length) * 100);
                this.publishPercentageSyncAttendance(percent);
              } catch (error) {
                console.log('TCL: error percentage', error);
              }

              count++;
            }

          this.resetProgressSyncRawAttendance();
          }
        } catch (error) {
          console.log('TCL: error set data tenant', error);
        }

				const response = {
					usersSuccessUploaded: [...setEmployee.usersSuccessUploaded, ...setGuest.usersSuccessUploaded, ...setTenant.usersSuccessUploaded],
					userNotQualifiedFoto: [...setEmployee.userNoQualifiedFoto, ...setGuest.userNoQualifiedFoto, ...setTenant.userNoQualifiedFoto],
					userErrorUploadFoto: [...setEmployee.userErrorUploadFoto, ...setGuest.userErrorUploadFoto, ...setTenant.userErrorUploadFoto],
					userFotoToUpload: setEmployee.userFotoToUpload + setGuest.userFotoToUpload + setTenant.userFotoToUpload,
					usersNotInDevice: [...setEmployee.usersNotInDevice, ...setGuest.usersNotInDevice, ...setTenant.usersNotInDevice]
				}

				result.push({ deviceId: item.id, deviceName: item.name, result: response, success: true });
			} catch (error) {
				result.push({ deviceId: item.id, deviceName: item.name, result: null, success: false });
				console.log(error);
			}
		}

		return { result: result };
	}

	async syncUptodatePhotosToDevices(data: ResponseDevice[]) {
		const dataFilter = data.filter(x => x.connected == true);
		const photos = await this.getLatestPhoto();
		try {
			console.log('data filter', dataFilter)
			for (const item of dataFilter) {
				this.thermalApi.setBaseUrl(item.host);
				await this.syncFotoUptodate(photos)
			}
			return true;
		} catch (error) {
			console.log(error);
			throw error;
		}
	}

	async syncUserNotInSpecificDevice(data: ResponseDevice, machineCode: string): Promise<ResponseSyncUserNotInSpecificDevice> {
		try {
			const persons = data.user.map((x: any) => x.userId);
			const userNotDevice = await this.faceThermalApi.getUserNotInDevice(persons).toPromise();
			// const guestNotDevice = await this.faceThermalApi.getGuestNotInDevice(persons).toPromise();
			// const tenantNotInDevice = await this.faceThermalApi.getTenantNotInDevice(persons).toPromise();

			let setEmployee: ResponseSetUserNotInDevice = { userErrorUploadFoto: [], userNoQualifiedFoto: [], usersSuccessUploaded: [], usersNotInDevice: [], userFotoToUpload: 0 };
			let setGuest: ResponseSetUserNotInDevice = { userErrorUploadFoto: [], userNoQualifiedFoto: [], usersSuccessUploaded: [], usersNotInDevice: [], userFotoToUpload: 0 };
			let setTenant: ResponseSetUserNotInDevice = { userErrorUploadFoto: [], userNoQualifiedFoto: [], usersSuccessUploaded: [], usersNotInDevice: [], userFotoToUpload: 0 };;

      let count = 1;

			try {
				if (userNotDevice.data.length > 0){
          for (let item of userNotDevice.data) {
            const message = `Send ${count} of ${userNotDevice.data.length} data employee`;
				    this.publishProgressSyncAttendance(message);

            setEmployee = await this.setUserNotInDevices('employee', item, machineCode);
						console.log('TCL setEmployee',setEmployee);

            try {
              const percent = Math.ceil((count / userNotDevice.data.length) * 100);
              this.publishPercentageSyncAttendance(percent);
            } catch (error) {
              console.log('TCL: error percentage', error);
            }

            count++;
          }

        this.resetProgressSyncRawAttendance();
        }
			} catch (error) {
        console.log('TCL: error set data employee', error);
      }

			// try {
			// 	if (guestNotDevice.data.length > 0) {
      //     for (let item of guestNotDevice.data) {
      //       const message = `Send ${count} of ${guestNotDevice.data.length} data guest`;
			// 	    this.publishProgressSyncAttendance(message);

      //       setGuest = await this.setUserNotInDevices('guest', item, machineCode);

      //       try {
      //         const percent = Math.ceil((count / guestNotDevice.data.length) * 100);
      //         this.publishPercentageSyncAttendance(percent);
      //       } catch (error) {
      //         console.log('TCL: error percentage', error);
      //       }

      //       count++;
      //     }

      //   this.resetProgressSyncRawAttendance();
      //   }
			// } catch (error) {
      //   console.log('TCL: error set data guest', error);
      // }

			// try {
			// 	if (tenantNotInDevice.data.length > 0) {
      //     for (let item of tenantNotInDevice.data) {
      //       const message = `Send ${count} of ${tenantNotInDevice.data.length} data guest`;
			// 	    this.publishProgressSyncAttendance(message);

      //       setTenant = await this.setUserNotInDevices('tenant', item, machineCode);

      //       try {
      //         const percent = Math.ceil((count / tenantNotInDevice.data.length) * 100);
      //         this.publishPercentageSyncAttendance(percent);
      //       } catch (error) {
      //         console.log('TCL: error percentage', error);
      //       }

      //       count++;
      //     }

      //   this.resetProgressSyncRawAttendance();
      //   }
			// } catch (error) {
      //   console.log('TCL: error set data tenant', error);
      // }


			// console.log('TCL: syncUserNotInSpecificDevice',  [...resultEmployee, ...resultGuest, ...resultTenant])
			const response = {
				usersSuccessUploaded: [...setEmployee.usersSuccessUploaded, ...setGuest.usersSuccessUploaded, ...setTenant.usersSuccessUploaded],
				userNotQualifiedFoto: [...setEmployee.userNoQualifiedFoto, ...setGuest.userNoQualifiedFoto, ...setTenant.userNoQualifiedFoto],
				userErrorUploadFoto: [...setEmployee.userErrorUploadFoto, ...setGuest.userErrorUploadFoto, ...setTenant.userErrorUploadFoto],
				userFotoToUpload: setEmployee.userFotoToUpload + setGuest.userFotoToUpload + setTenant.userFotoToUpload,
				usersNotInDevice: [...setEmployee.usersNotInDevice, ...setGuest.usersNotInDevice, ...setTenant.usersNotInDevice]
			}

			return response;
		} catch (error) {
			console.log('error sync', error);
			throw error;
		}
	}

	async getEmployeeNotInDevice(data: ResponseDevice, filteredItems?) {
		try {
			const persons = data.user.map((x: any) => x.userId);
			let type;
			let filterId;
			if (filteredItems) {
				type = filteredItems.type;
				filterId = filteredItems.filterId;
			}
			const userNotDevice = await this.faceThermalApi.getUserNotInDevice(persons, type, filterId).toPromise();
			return userNotDevice.data;
		} catch (error) {
			console.log(error);
		}
	}

	async getGuestNotInDevice(data: ResponseDevice) {
		try {
			const persons = data.user.map((x: any) => x.userId);
			const userNotDevice = await this.faceThermalApi.getGuestNotInDevice(persons).toPromise();
			return userNotDevice.data;
		} catch (error) {
			console.log(error);
		}
	}

	async getTenantNotInDevice(data: ResponseDevice) {
		try {
			const persons = data.user.map((x: any) => x.userId);
			const userNotDevice = await this.faceThermalApi.getTenantNotInDevice(persons).toPromise();
			return userNotDevice.data;
		} catch (error) {
			console.log(error);
		}
	}

	async setUserNotInDevice(type: 'employee' | 'guest' | 'tenant', userNotDevice: any, machineCode: any): Promise<ResponseSetUserNotInDevice> {
		let SFGoAuth = await this.appPreferences.getAuth();
		let storage = await this.storagePathProvider.getStorageItcs(SFGoAuth);
		let usersFoto = [];
		let count = 1;
		let data = {
			userNoQualifiedFoto: [],
			userErrorUploadFoto: [],
			userFotoToUpload: 0,
			usersSuccessUploaded: [],
			usersNotInDevice: [],
			userIds: []
		}

		for (let item of userNotDevice) {
			const userId = type == 'employee' ? item.userId : type == 'guest' ? item.idcardNumber : item.id;
			const fullName: string = type == 'employee' ? item.fullName : type == 'guest' ? item.guestFullname : item.fullName;

			// data.userIds.push(userId);

      data.userIds = [userId]

			data.usersNotInDevice.push({
				"userId" : userId,
				// "idcardNum": "",
				"fullName": fullName ? this.titleCasePipe.transform(fullName) : fullName
			});

			if (item.tgospfaceuserphotos.length > 0) {
				usersFoto.push({
					"personId": userId,
					"photos": item.tgospfaceuserphotos,
					"fullName": fullName
				});
			};

			const message = `Send ${count} of ${userNotDevice.length} data employee`;
			this.publishProgressSyncAttendance(message);
			
			try {
				const percent = Math.ceil((count / userNotDevice.length) * 100);
				this.publishPercentageSyncAttendance(percent);
			} catch (error) {
				console.log('TCL: error percentage', error);
			}

			try {
				const createBatchPerson: any = await this.faceThermalApi.syncUserTigersoft(data.userIds, machineCode).toPromise();
				console.log('TCL: createBatchPerson', createBatchPerson);
				if (createBatchPerson && createBatchPerson.success == false) {
					throw createBatchPerson.msg || 'invalid data';
				}
				data.usersSuccessUploaded = data.usersNotInDevice;
			} catch (error) {
				console.log('TCL: error createBatch', error);
				throw error;
			}

			count++;
		}

		for (const emp of usersFoto) {
			for (const item of emp.photos) {
				try {
					item.imageBase64 = await this.globalServiceProvider.getBase64ImageFromURL(storage.urlDownload + item.photo).toPromise();
					let createUserPhoto: any = await this.faceApi.create('12345678', emp.personId, '', item.imageBase64);
					if (createUserPhoto && !createUserPhoto.success && createUserPhoto.code == '2000') {
						let checkIdx = data.userNoQualifiedFoto.findIndex(data => data.personId == emp.personId);
						if (checkIdx == -1) {
							data.userNoQualifiedFoto.push({ personId: emp.personId, fullName: emp.fullName })
						}
						await this.faceThermalApi.notQualified({ id: emp.personId }).toPromise();
					}
				} catch (error) {
					let checkIdx = data.userErrorUploadFoto.findIndex(data => data.personId == emp.personId);
					if (checkIdx == -1) {
						data.userErrorUploadFoto.push({ personId: emp.personId, fullName: emp.fullName })
					}
					console.log('TCL: error setUserNotInDevice', error)
				}
			}
		}

		try {
			if (usersFoto.length) {
				data.userFotoToUpload = usersFoto.map(item => item.photos.length).reduce((a, b) => a + b);
			}
		} catch (_) { }

		console.log('TCL data',data);

		return data;
	}

	async setUserNotInDeviceTigersoft(userNotDevice: any, machineCode: any): Promise<ResponseSetUserNotInDevice> {
		let data = {
			userNoQualifiedFoto: [],
			userErrorUploadFoto: [],
			userFotoToUpload: 0,
			usersSuccessUploaded: [],
			usersNotInDevice: [],
			userIds: []
		}

		const userId = userNotDevice.map((val) => { return val.userId })

		for (let item of userNotDevice) {
			const userId = item.userId
			const fullName: string = item.fullName

			data.usersNotInDevice.push({
				"userId" : userId,
				"fullName": fullName ? this.titleCasePipe.transform(fullName) : fullName
			});
		}

		try {
			const createBatchPerson: any = await this.faceThermalApi.syncUserTigersoft(userId, machineCode).toPromise();
			console.log('TCL: createBatchPerson', createBatchPerson);
			data.usersSuccessUploaded = data.usersNotInDevice
		} catch (error) {
			console.log('TCL: error createBatch', error);
			throw error;
		}

		return data;
	}

  async setUserNotInDevices(type: 'employee' | 'guest' | 'tenant', userNotDevice: any, machineCode: string): Promise<ResponseSetUserNotInDevice> {
		let SFGoAuth = await this.appPreferences.getAuth();
		let storage = await this.storagePathProvider.getStorageItcs(SFGoAuth);
		let usersFoto = [];
    let userNotInDevice = [];
		let userIds = [];

		const userId = type == 'employee' ? userNotDevice.userId : type == 'guest' ? userNotDevice.idcardNumber : userNotDevice.id;
		const fullName: string = type == 'employee' ? userNotDevice.fullName : type == 'guest' ? userNotDevice.guestFullname : userNotDevice.fullName;

		userIds.push(userId);

		userNotInDevice.push({
			"userId" : userId,
			"fullName" : fullName ? this.titleCasePipe.transform(fullName) : fullName
		});

    this.userNotDevice.usersNotInDevice.push(userNotInDevice);

    if (userNotDevice.tgospfaceuserphotos.length > 0) {
			usersFoto.push({
				"personId": userId,
				"photos": userNotDevice.tgospfaceuserphotos,
				"fullName": fullName,
			});
		};

		// try {
		// 	const createBatchPerson: any = await this.personsApi.createBatchPerson('12345678', userNotInDevice);
		// 	console.log('TCL: createBatchPerson', createBatchPerson);
		// 	if (createBatchPerson && createBatchPerson.success == false) {
		// 		throw createBatchPerson.msg || 'invalid data';
		// 	}
		// 	this.userNotDevice.usersSuccessUploaded.push(userNotInDevice);
		// } catch (error) {
		// 	console.log('TCL: error createBatch', error);
		// 	throw error;
		// }

		try {
			const createBatchPerson: any = await this.faceThermalApi.syncUserTigersoft(userIds, machineCode).toPromise();
			console.log('TCL: createBatchPerson', createBatchPerson);
			if (createBatchPerson && createBatchPerson.success == false) {
				throw createBatchPerson.msg || 'invalid data';
			}
			this.userNotDevice.usersSuccessUploaded.push(userNotInDevice);
		} catch (error) {
			console.log('TCL: error createBatch', error);
			throw error;
		}

		for (const emp of usersFoto) {
			for (const item of emp.photos) {
				try {
					item.imageBase64 = await this.globalServiceProvider.getBase64ImageFromURL(storage.urlDownload + item.photo).toPromise();
					let createUserPhoto: any = await this.faceApi.create('12345678', emp.personId, '', item.imageBase64);
					if (createUserPhoto && !createUserPhoto.success && createUserPhoto.code == '2000') {
						let checkIdx = this.userNotDevice.userNoQualifiedFoto.findIndex(data => data.personId == emp.personId);
						if (checkIdx == -1) {
							this.userNotDevice.userNoQualifiedFoto.push({ personId: emp.personId, fullName: emp.fullName })
						}
						await this.faceThermalApi.notQualified({ id: emp.personId }).toPromise();
					}
				} catch (error) {
					let checkIdx = this.userNotDevice.userErrorUploadFoto.findIndex(data => data.personId == emp.personId);
					if (checkIdx == -1) {
						this.userNotDevice.userErrorUploadFoto.push({ personId: emp.personId, fullName: emp.fullName })
					}
					console.log('TCL: error setUserNotInDevice', error)
				}
			}
		}

		try {
			if (usersFoto.length) {
				this.userNotDevice.userFotoToUpload = usersFoto.map(item => item.photos.length).reduce((a, b) => a + b);
			}
		} catch (_) { }

		return this.userNotDevice;
	}

	async removeUser(id: any) {
		try {
			return await this.personsApi.delete('12345678', id);
		} catch (error) {
			console.log(error);
			throw error.error;
		}
	}

	async removeUserTigersoft(id: any, machineCode: any) {
		const deleteFromTigersoft: boolean = false;

		try {
			const ids = [];
			ids.push(id);

			return await this.faceThermalApi.deleteTigersoft(ids, machineCode, deleteFromTigersoft).toPromise();
		} catch (error) {
			console.log(error);
			throw error.error;
		}
	}

	async getPhotoInServer(personId: any) {
		try {
			const data = await this.faceThermalApi.getUserPhotos(personId).toPromise();
			return data.data;
		} catch (error) {
			throw error;
		}
	}

	async getPhotoInDevice(personId: any) {
		try {
			const data: any = await this.faceApi.find('12345678', personId);
			return data;
		} catch (error) {
			throw error;
		}
	}

	async getNewRecord() {
		try {
			const data: any = await this.attendanceApi.findRecords('12345678', -1, -1, 0, 0, 0, -1);
			const response = data;
			if (response.success) {
				return response.data;
			} else {
				return [];
			}
		} catch (error) {
			throw error;
		}
	}

	async syncRawData(device: any, data: any[]): Promise<ResponseSyncRawData> {
		const tempDataSuccess = [];
		const tempDataError = [];
		let count = 1;

		for await (let item of data) {
			try {
				let base64 = '';
				const message = `Send ${count} of ${data.length} data`;
				this.publishProgressSyncAttendance(message);

				try {
					const resultBase64 = await this.globalServiceProvider.getBase64ImageFromURL(item.path).toPromise();
					base64 = `data:image/jpeg;base64,${resultBase64}`;
				} catch (e) {
					console.log('TCL: error convert base64', e);
				}

				try {
					const percent = Math.ceil((count / data.length) * 100);
					this.publishPercentageSyncAttendance(percent);
				} catch (error) {
					console.log('TCL: error percentage', error);
				}

				await this.faceThermalApi.saveRecordFace({
					standard: device.temperature,
					searchScore: '0',
					ip: device.host,
					deviceKey: device.name,
					type: item.type,
					token: "0",
					path: item.path,
					imgBase64: `${base64}`,
					temperature: item.temperature,
					personId: item.personId,
					time: item.time,
					temperatureState: item.temperatureState,
					livenessScore: "0",
				}).toPromise();

				tempDataSuccess.push(item);

				// hapus data yang success di sync ke server
				await this.attendanceApi.newDeleteRecords(item);
			} catch (error) {
				tempDataError.push(item);
			}

			count++;
		}

		return { syncSuccess: tempDataSuccess, syncError: tempDataError };
	}

	resetProgressSyncRawAttendance() {
		this._percentageSyncAttendance = 0;
		this._progressSyncAttendance = '';
	}

	async getUserNotif(page: number, search: string): Promise<ResponsePaging<ResponseEmployeeNotif>> {
		try {
			const data = await this.faceThermalUserApi.getEmployeeNotif(page, search).toPromise();
			return data;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				const message = this.nestResponsesProvider.handleMsgError(error);
				throw message;
			}
		}
	}

	async setConfig(item: any) {
		try {
			this.thermalApi.setBaseUrl(item.host);
			const password = '12345678';

			let company: { companyName: string, companyCode: string, companyId: number } = await this.appPreferences.getCompanyData();
			let logo = await this.faceThermalApi.getLogoGreatday().toPromise();
			let base64: string = await this.globalServiceProvider.convertFileToBase64(logo.body)
			base64 = base64.substring(base64.indexOf('base64,') + 7);
			if (!company) {
				company.companyName = 'GreatDayHR';
			}

			let changeLogo = await this.configApi.changeLogo(password, base64).catch(() => { });
			console.log('changeLogo', changeLogo);
			let setConfig = await this.configApi.setConfig(password, company.companyName);
			console.log('setConfig', setConfig)
			let setMaskConfig = await this.configApi.setMaskConfig(password, item.showMask);
			console.log('setMaskConfig', setMaskConfig);
			let setTemperatureConfig = await this.configApi.setTemperatureConfig(password, item.temperature);
			console.log('setTemperatureConfig', setTemperatureConfig);
			let setIdentifyCallBack = await this.attendanceApi.setIdentifyCallBack('12345678', item.urlCallback);
			console.log('setIdentifyCallBack', setIdentifyCallBack);

			return true;
		} catch (error) {
			console.log('error', error);
			throw 'Failed set config';
		}
	}

	// ATAS BABAY

	// BAWAH NASA

	async deleteUserPhoto(id: number) {
		try {
			const result = await this.faceThermalApi.deleteUserPhoto(id).toPromise();
			return result;
		} catch (error) {
			throw error;
		}
	}

	async takePicture(sourceType: number) {
		try {
			const options: CameraOptions = {
				sourceType: sourceType // camera
			}

			const getPicture = await this.cameraNative.getPicture(options);
			return getPicture;
		} catch (error) {
			throw error;
		}
	}

	async imagePicker(options: ImagePickerOptions) {
		try {
			const getPicture = await this.imagePickerNative.getPictures(options);
			return getPicture;
		} catch (error) {
			throw error;
		}
	}

	async upload(nativeUri: string, personId: any) {
		try {
			const options: OptionsUploadWithHttp = {
				options: null,
				type: 'image',
				eventsWebview: null,
				nativeURI: nativeUri,
				body: { personId: personId },
				name: 'photo'
			}

			const url = this.faceThermalApi.urlAddUserPhoto();
			const result = await this.fileUploader.uploadWithHttpCustom(options, url);
			return result;
		} catch (error) {
			throw error;
		}
	}

	async batchUpload(images: string[], type: string) {
    console.log('check image:', images);
		try {
      if (type == 'employee') {
        // const url = this.faceThermalApi.urlUploadMultiple();
        const url = this.faceThermalApi.urlUploadMultipleTigersoft();
			  const result = await this.batchUploadFileTransfer(url, images)
			  console.log('result upload', result);
			  return result;
      } else if (type == 'tenant') {
        const url = this.faceThermalApi.urlUploadMultipleTenant();
			  const result = await this.batchUploadFileTransfer(url, images)
			  console.log('result upload', result);
			  return result;
      }
		} catch (error) {
			throw error;
		}
	}

	batchUploadFileTransfer(urlUpload: string, images: string[]) {
		return new Promise(async (resolve, reject) => {
			let bodies: FormDataUpload[] = [];

			for (let image of images) {
				let file: any = image;
				let filename: string = this.platform.is('cordova') ? file : file.name;
				let idxUnderscore = filename.lastIndexOf('_');

				if (this.platform.is('cordova')) {
					file = await this.fileUploader.processFileFromUri(image);

					filename = idxUnderscore != -1 ? `${image.substring(image.lastIndexOf('/') + 5, idxUnderscore)}.jpg` : filename;
					bodies.push({ name: 'files', value: file, fileName: filename })
				} else {
					// filename = idxUnderscore != -1 ? `${filename.substring(0, idxUnderscore)}.jpg` : filename;
					bodies.push({ name: 'files', value: image, fileName: filename })
				}
			}

			const options: FileTransferHttpOptions = {
				url: urlUpload,
				method: 'POST',
				body: bodies
			}

			this.fileTransferNative.uploadHttp(options)
				.subscribe((event: HttpEvent<any>) => {
					if (event.type === HttpEventType.UploadProgress) {
						this.fileUploader.percentageProgress = Math.round(100 * event.loaded / event.total);
						console.log(`File is ${this.fileUploader.percentageProgress}% uploaded.`);
					} else if (event.type === HttpEventType.Response) {
						const body = event.body;
						let result = body.data;
						resolve(result);
					}
				}, error => {
					reject(error);
				});
		})
	}

	async create(personId: any, faceId: any, base64: any, pass: string = '12345678') {
		try {
			const data: any = await this.faceApi.create(pass, personId, faceId, base64);
			const response = data;
			console.log('response create', response)
			if (response.success) {
				return response;
			} else {
				throw response.msg;
			}
		} catch (error) {
			console.log('response create error', error)
			throw error;
		}
	}

	async deletePerson(personId, pass: string = '12345678') {
		try {
			const data = await this.faceApi.deletePerson(pass, personId);
			return data;
		} catch (error) {
			throw error;
		}
	}

	getEmployeeNotif(page: number, search?: string) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalUserApi.getEmployeeNotif(page, search)
					.subscribe(result => {
						resolve(result)
							, error => {
								reject(error);
							}
					})
			)
		})
	}

	setEmployeeNotif(payload: RequestEmployeeNotif) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalUserApi.setEmployeeNotif(payload)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error);
					})
			)
		})
	}

	deleteEmployeeNotif(email: string) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalUserApi.deleteEmployeeNotif(email)
					.subscribe(result => {
						resolve(result)
							, error => {
								reject(error);
							}
					})
			)
		})
	}

	editEmployeeNotif(payload: RequestEmployeeNotif) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalUserApi.editEmployeeNotif(payload)
					.subscribe(result => {
						resolve(result)
							, error => {
								reject(error);
							}
					})
			)
		})
	}

	getEmployeesToAdd(page: number, limit: number, keyword: string) {
		return new Promise<ResponseSearchDto>((resolve, reject) => {
			const params = {
				dataAuth: false,
				paging: true,
				userId: "",
				empId: "",
				fullName: keyword,
				gender: "",
				positionId: [],
				active: '1'
			};

			const queryParams = { page: page, limit: limit };

			this.subscriptions.push(
				this.employeesApi.getEmp(params, queryParams)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	getAdmin() {
		return new Promise<any>((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalDashboardUserLoginApi.getAdmin()
					.map(response => response.data)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	setAdmin(payload: RequestDashboardUserLoginDto) {
		return new Promise<any>((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalDashboardUserLoginApi.setAdmin(payload)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	highTemperatures(payload: { page: number, limit: number }) {
		return new Promise<ResponsePaging<any>>((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalUserApi.highTemperatures(payload)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	notQualified(id: string) {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalApi.notQualified({ id: id })
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	syncFaceUserFromProfile() {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalApi.syncFaceUserFromProfile()
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	phoneCall(phoneNumber) {
		return new Promise(async (resolve, reject) => {
			try {
				await this.callNumber.isCallSupported();
				await this.callNumber.callNumber(phoneNumber, true);
				resolve(true)
			}
			catch (error) {
				reject(error)
			}
		})
	}

	async convertUriToBase64(uri: string) {
		try {
			const path = this.globalServiceProvider.getFilePath(uri);
			console.log('path', path)
			const file = await this.globalServiceProvider.convertUriToFile(path.path, path.filename);
			let base64: any = await this.globalServiceProvider.convertFileToBase64(file);
			let partOfBase64 = base64.substr(base64.indexOf(',') + 1);
			return { base64: base64, partOfBase64: partOfBase64 }
		} catch (error) {
			throw error;
		}
	}

	paginate(array, page_number, page_size) {
		return array.slice((page_number - 1) * page_size, page_number * page_size);
	}

	deleteAllUsers(machineCode, deleteFromTigerSoft) {
		return new Promise(async (resolve, reject) => {
			try {
				// let result: any = await this.personsApi.delete('12345678', -1);
				let result: any = await this.faceThermalApi.deleteAllTigersoft([0], machineCode, deleteFromTigerSoft).toPromise();
				console.log('TCL: delete', result)
				if (result && result.success == false) {
					let error = result.msg || 'error delete';
					reject(error);
				}
				resolve(result)
			} catch (error) {
				console.log('TCL: DELETEALLUSER ERROR', error);
				reject(error);
			}
		})
	}

	listingUserTenant(payload: { page: number, limit: number }) {
		return new Promise<ResponsePaging<ResponseListingUserTenant>>((resolve, reject) => {
			this.faceThermalApi.listingUserTenant(payload)
				.subscribe((result) => {
					resolve(result)
				}, error => {
					reject(error);
				})
		})
	}

	listingCompanyTenant(payload: { page: number, limit: number }) {
		return new Promise<ResponsePaging<RequestListingCompanyTenant>>((resolve, reject) => {
			this.faceThermalApi.listingCompanyTenant(payload)
				.subscribe((result) => {
					resolve(result)
				}, error => {
					reject(error);
				})
		})
	}

	attendanceTempDetailLoc(payload: RequestAttendanceTempLog) {
		return new Promise<ResponsePaging<ResponseAttendanceTempDetailLoc>>((resolve, reject) => {
			this.faceThermalApi.attendanceTempDetailLoc(payload)
				.subscribe((result) => {
					resolve(result)
				}, error => {
					reject(error);
				})
		})
	}

	saveCompanyTenant(payload: RequestSaveCompanyTenant) {
		return new Promise<ResponseData<any>>((resolve, reject) => {
			this.faceThermalApi.saveCompanyTenant(payload)
				.subscribe((result) => {
					resolve(result)
				}, error => {
					reject(error);
				})
		})
	}

	saveUserTenant(payload: RequestSaveUserTenant) {
		return new Promise<ResponseData<any>>((resolve, reject) => {
			this.faceThermalApi.saveUserTenant(payload)
				.subscribe((result) => {
					resolve(result)
				}, error => {
					reject(error);
				})
		})
	}

	getLatestPhoto() {
		return new Promise<Array<any>>((resolve, reject) => {
			this.subscriptions.push(
				this.faceThermalApi.getLatestPhoto()
					.map(res => res.data)
					.subscribe(result => {
						resolve(result)
					}, error => {
						reject(error)
					})
			)
		})
	}

	async syncFotoUptodate(photos: any[]) {
		const storage = await this.storagePathProvider.getStorageItcs(await this.appPreferences.getAuth());
		for (const item of photos) {
			try {
				item.imageBase64 = await this.globalServiceProvider.getBase64ImageFromURL(storage.urlDownload + item.photo).toPromise();
				let createUserPhoto: any = await this.faceApi.create('12345678', item.personId, '', item.imageBase64).catch(() => { });
				if (createUserPhoto && !createUserPhoto.success && createUserPhoto.code == '2000') {
					await this.faceThermalApi.notQualified({ id: item.personId }).toPromise();
				}
			} catch (error) {
				console.log('error convert base64', error)
			}
		}
		return photos;
	}

	async deleteExpireGuest(deviceList: ResponseDevice[]) {
		try {
			const devices = deviceList.filter(x => x.connected == true);
			const expireGuest: any[] = await this.expiredGuest();
			if (expireGuest.length) {
				for (let device of devices) {
					this.thermalApi.setBaseUrl(device.host);
					for (let guest of expireGuest) {
						try {
							await this.removeUser(guest);
						} catch (_) { }
					}
				}
			}
		} catch (error) {
			throw error;
		}
	}

	expiredGuest() {
		return new Promise<Array<any>>((resolve, reject) => {
			const today = moment().toISOString();
			this.faceThermalApi.expiredGuest(today)
				.map(res => res.data)
				.subscribe(result => {
					resolve(result)
				}, error => {
					reject(error);
				})
		})
	}

	downloadTemplateTenant() {
		return new Promise((resolve, reject) => {
			this.subscriptions.push(
				this.attendanceFaceRecognizeApi.downloadTemplateTenant()
					.subscribe((result) => {
						resolve(result)
					}, error => {
						reject(error);
					})
			)
		})
	}

	uploadFileUserTenant(file: File, fileName: string) {
		return new Promise<ResponseData<any>>((resolve, reject) => {
			this.subscriptions.push(
				this.attendanceFaceRecognizeApi.uploadFileUserTenant(file, fileName)
					.subscribe((result) => {
						resolve(result)
					}, error => {
						reject(error);
					})
			)
		})
	}

	listingTimeZone() {
		return new Promise<ResponsePaging<RequestListingTimeZone>>((resolve, reject) => {
			this.faceThermalApi.listingTimeZone()
      .subscribe((result) => {
        resolve(result)
      }, error => {
        reject(error)
      })
		})
	}

	async syncUserZkteco() {
    try {
      const person = await this.faceThermalApi.getUserNotInDevice([]).toPromise();
      console.log('TCL person length', person.data.length);

      let count = 1;

      try {
        if (person.data.length > 0) {
          for (let item of person.data) {

            const message = `send ${count} of ${person.data.length} data employee`;
            this.publishProgressSyncAttendance(message);
            const ids = [item.userId];
            const result = await this.faceThermalApi.zktecoSyncUser(ids).toPromise();
            try {
              const percent = Math.ceil((count / person.data.length) * 100);
              this.publishPercentageSyncAttendance(percent);
            } catch (error) {
              console.log('TCL: error percentage', error);
            }

            count++;
          }

          this.resetProgressSyncRawAttendance();
        }
      } catch (error) { }
    } catch (error) { }
  }

	async getEmpTigersoft(item: any) {
		try {
			try {
				const persons: any = await this.faceThermalApi.getEmpTigersoft(item.uuid).toPromise();
				console.log('persons', persons);

				const response = persons;
				item.user = response.data;
			} catch (error) {
				console.log('TCL getEmpTigersoft Error :',error);
			}
			return item;
		} catch (error) {
			if (typeof error === 'string') {
				throw error;
			} else {
				throw this.nestResponsesProvider.handleMsgError(error);
			}
		}
	}

	async getWorkLocation() {
		try {
			const results = await this.faceThermalApi.getWorkLocation().toPromise();
			return results.data;
		} catch (error) {
			console.log(error);
		}
	}

	async getDepartment() {
		try {
			const results = await this.faceThermalApi.getDepartment().toPromise();
			return results.data;
		} catch (error) {
			console.log(error);
		}
	}

}



// WEBPACK FOOTER //
// ./src/bloc/feature/face-thermal/face-thermal.bloc.ts